import { requestOpen, enetApiUrl } from '@/utils';

let enetHost = process.env.VUE_APP_ENET_DEFAULT_API;
const curOrigin = window.location.origin;
if (enetApiUrl[curOrigin]) {
  enetHost = enetApiUrl[curOrigin];
}

// 商品管理对外开放API
const OpenProdSpu = {
  getProductInfoByIdOpen: `${enetHost}/api/v1/schemes/mall/prod/batch/info`, // 根据产品ID批量查询
  prodAttributeSubtreeOpen: `${enetHost}/api/v1/schemes/mall/attr/new/list`, // 查看分类的所有属性
  getVideoMaterial: `${enetHost}/s2b2capi/material/query`
};

export const getProductInfoByIdOpen = (data = {}) => {
  return requestOpen({
    api: OpenProdSpu.getProductInfoByIdOpen,
    method: 'POST',
    query: data.query || {},
    params: data.body || {}
  });
};

export const prodAttributeSubtreeOpen = (data = {}) => {
  return requestOpen({
    api: OpenProdSpu.prodAttributeSubtreeOpen,
    method: 'GET',
    query: data.query || {},
    params: data.body || {}
  });
};

//获取产品详情
export const getProductInfo = (data = {}) => {
  return requestOpen({
    api: OpenProdSpu.getProductInfoByIdOpen,
    method: 'GET',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getVideoMaterial = (data = {}) => {
  return requestOpen({
    api: OpenProdSpu.getVideoMaterial,
    method: 'POST',
    querys: data.query || {},
    params: data.body || {}
  });
};
